/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Tip_Rooms_TInputs */



/**
* | output |
* | --- |
* | "Name your rooms" |
*
* @param {Tournament_Wiz_Tip_Rooms_TInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_tip_rooms_t = /** @type {((inputs?: Tournament_Wiz_Tip_Rooms_TInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Tip_Rooms_TInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nommez vos salles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ponga nombre a sus salas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Dê nome às suas salas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dai un nome alle tue sale")
	return /** @type {LocalizedString} */ ("Name your rooms")
});